let _klavyoBisRetries = 10;

async function init() {
  const klaviyo = window.klaviyo;
  if (klaviyo) {
    const accountId = await klaviyo.account();

    if (!accountId)
      return retry();

    klaviyo.init({
      account: accountId,
      platform: "shopify"
    });
    klaviyo.enable("backinstock", {
      trigger: {
        product_page_class: 'btn btn--full'
      },
      modal: {
        headline: "{product_name}",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Montserrat'); #container {border-radius: 10px} .submit-container .btn {border-radius: 88px}",
        font_family: 'Montserrat, sans-serif',
        ...window.klaviyoThemeSettings
      }
    });
  } else {
    return retry();
  }
}

async function retry() {
  _klavyoBisRetries--;
  if (_klavyoBisRetries < 0) {
    console.error("Can't load Klaviyo BIS");
    return;
  }
  await new Promise((resolve) => { setTimeout(resolve, 100); });
  return await init();
}

init();
